import { FieldSchema, FieldValueObject, isEmpty, EMPTY_VALUE } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { getEquipmentModels } from "../external-sources/CategoryMappings";
import { SchemaContext } from "../../common";
import { EntryTypes } from "./entryType";
import { Modes } from "./mode";

export const createEquipmentModel = (context: SchemaContext): FieldSchema => ({
  grid: {
    displayed: true,
    order: 1,
    filter: GridFilterTypes.SET,
    permanent: true,
    // Set filter without a `data` enum: assigned through the MasterDataPicker, so the options
    // are grid-scoped. Merges equipment and cluster models, as the grid lists both.
    filterValues: { getter: () => getEquipmentModels(context.client) },
  },
  name: "equipmentModel",
  data: {
    assignedValue: {
      getter: ({ equipmentModel, masterDataPicker, mode }) => {
        // See `equipmentCategory`: in a CSV the column wins over the picker rebuilt from
        // the stored record.
        if (masterDataPicker && mode !== Modes.CSV) {
          return (masterDataPicker as FieldValueObject)?.equipmentModel ?? EMPTY_VALUE;
        }
        return isEmpty(equipmentModel) ? EMPTY_VALUE : equipmentModel;
      },
      fields: ["masterDataPicker", "mode"],
    },
  },
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: {
    label: "Model",
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
});
